import { PropsWithChildren, useRef } from 'react';

import { createModelConfigStore, ModelConfigContext, ModelConfigProps, ModelConfigStore } from './modelConfigStore';

type ModelConfigProviderProps = PropsWithChildren<ModelConfigProps>;

export const ModelConfigProvider = ({ children, modelId, ...props }: ModelConfigProviderProps) => {
  const storeRef = useRef<ModelConfigStore>(null);

  if (!storeRef.current) {
    storeRef.current = createModelConfigStore({ modelId, ...props });
  }

  if (storeRef.current?.getState().modelId !== modelId) {
    storeRef.current = createModelConfigStore({ modelId, ...props });
  }

  return <ModelConfigContext.Provider value={storeRef.current}>{children}</ModelConfigContext.Provider>;
};
